module.exports = __webpack_public_path__ + "ce7eba7b3fd5d41bdb6503d1939d9f31.png";